import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
// import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Event Sphere',
        projectDesc: 'This project intends to develop an event management system that integrates all ongoing and forthcoming events within a city.',
        tags: ['Java', 'Spring Boot', 'React'],
        code: 'https://github.com/shivarahul/EventSphere',
        demo: 'https://github.com/shivarahul/EventSphere',
        image: one
    },
    {
        id: 2,
        projectName: 'FleetMaster',
        projectDesc: 'This project involves the development of a fleet management system designed to provide users with comprehensive information regarding fleet rentals and operational activities.',
        tags: ['Java', 'Spring','Thymeleaf'],
        code: 'https://github.com/shivarahul/FleetMaster',
        demo: 'https://github.com/shivarahul/FleetMaster',
        image: two
    },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/